import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/panxo/Development/QC-AI/web/src/components/layout/Footer.tsx");
